export enum Identity {
  Provider = 'provider',
  Representative = 'representative',
}
